module.exports = __webpack_public_path__ + "img/logo-isc-transparent.2b37ca6a.png";